import * as React from 'react';

import {NucleotideType, stripDegenerate} from 'biojs/Util';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import TextField from 'ui-library/inputs/TextField';

interface PreRecognitionSiteBasesProps {
  preRecognitionSiteBases: string;
  updatePreRecognitionSiteBases: (preRecognitionSiteBases: string) => void;
  isDisabled: boolean;
}

/**
 * An input to set pre-recognition site bases in Golden Gate assembly.
 *
 * @param props Component props
 * @param {string} props.preRecognitionSiteBases A string of bases to use as a pre-recognition site.
 * @param {function} props.updatePreRecognitionSiteBases A function that takes a new string of bases and uses it to update state.
 * @constructor
 */
export function PreRecognitionSiteBases(props: PreRecognitionSiteBasesProps): JSX.Element {
  return (
    <TextField
      placeholder="Enter bases"
      label="Pre-recognition site - bases"
      labelStyle={LabelStyle.LABEL}
      value={props.preRecognitionSiteBases}
      onChange={(e) => {
        props.updatePreRecognitionSiteBases(stripDegenerate(e.target.value, NucleotideType.DNA));
      }}
      disabled={props.isDisabled}
    />
  );
}
